import React, { Fragment } from 'react'
import Icon from 'atoms/Icon'

export const editGroupFormatter = (cell, row, rowIndex, formatExtraData) => {
  return (
    <Fragment>
      {formatExtraData.allowEdit &&
        <Icon
          icon={'pen'}
          ml={'15%'}
          color={'#463291'}
          onClick={formatExtraData.edit(row)}
          showPointer={true}
        />
      }
    </Fragment>
  )
}